import React, { useEffect, useState } from "react";
import "./MainVideo.scss";
import LazyLoad from "react-lazyload";
import { FormattedMessage } from "react-intl";

function MainVideo({
  setPartOfVideo0,
  partOfVideo0,
  resetAnimation,
  currentLocale,
}) {
  const [fullScreen, setFullScreen] = useState(false);
  function isMobile() {
    if (window.innerWidth <= 700) {
      return true;
    } else {
      return false;
    }
  }
  useEffect(() => {
    if (partOfVideo0 !== null) {
      setTimeout(() => {
        resetAnimation(0, 0);
        setPartOfVideo0(0);
      }, 50);
    }
  }, [currentLocale]);
  return (
    <section id="introduction" className="above-video">
      <div>
        <h2>
          <FormattedMessage id="home.mainvideo.h" />
        </h2>
        <p>
          <FormattedMessage id="home.mainvideo.p" />
        </p>
      </div>
      <div id="video-wrapper">
        <div
          onClick={() => setFullScreen((prev) => !prev)}
          className={`video ${isMobile() && fullScreen ? "full-screen" : ""}`}
        >
          {currentLocale === "en" ? (
            <div key="d1">
              <lottie-player
                class={`video0 ${
                  (partOfVideo0 === 0 || partOfVideo0 === null) && "active"
                }`}
                src={`animations-en/main-video/data1.json`}
                background="transparent"
                speed="1"
              ></lottie-player>
              <LazyLoad offset={0} once>
                <lottie-player
                  class={`video1 ${partOfVideo0 === 1 && "active"}`}
                  src={`animations-en/main-video/data2.json`}
                  background="transparent"
                  speed="1"
                ></lottie-player>
                <lottie-player
                  class={`video2 ${partOfVideo0 === 2 && "active"}`}
                  src={`animations-en/main-video/data3.json`}
                  background="transparent"
                  speed="1"
                ></lottie-player>
                <lottie-player
                  class={`video3 ${partOfVideo0 === 3 && "active"}`}
                  src={`animations-en/main-video/data4.json`}
                  background="transparent"
                  speed="1"
                ></lottie-player>
              </LazyLoad>
            </div>
          ) : (
            <div key="d2">
              <lottie-player
                class={`video0 ${
                  (partOfVideo0 === 0 || partOfVideo0 === null) && "active"
                }`}
                src={`animations-cs/main-video/data1.json`}
                background="transparent"
                speed="1"
              ></lottie-player>
              <LazyLoad offset={0} once>
                <lottie-player
                  class={`video1 ${partOfVideo0 === 1 && "active"}`}
                  src={`animations-cs/main-video/data2.json`}
                  background="transparent"
                  speed="1"
                ></lottie-player>
                <lottie-player
                  class={`video2 ${partOfVideo0 === 2 && "active"}`}
                  src={`animations-cs/main-video/data3.json`}
                  background="transparent"
                  speed="1"
                ></lottie-player>
                <lottie-player
                  class={`video3 ${partOfVideo0 === 3 && "active"}`}
                  src={`animations-cs/main-video/data4.json`}
                  background="transparent"
                  speed="1"
                ></lottie-player>
              </LazyLoad>
            </div>
          )}
        </div>
        <div className="timeline-wrapper">
          <div className="texts-wrapper">
            <p
              className={`${partOfVideo0 === 0 && "active"}`}
              onClick={() => {
                resetAnimation(0, 0);
                setPartOfVideo0(0);
              }}
            >
              <FormattedMessage id="home.mainvideo.text1" />
            </p>
            <p
              className={`${partOfVideo0 === 1 && "active"}`}
              onClick={() => {
                resetAnimation(1, 0);
                setPartOfVideo0(1);
              }}
            >
              <FormattedMessage id="home.mainvideo.text2" />
            </p>
            <p
              className={`${partOfVideo0 === 2 && "active"}`}
              onClick={() => {
                resetAnimation(2, 0);
                setPartOfVideo0(2);
              }}
            >
              <FormattedMessage id="home.mainvideo.text3" />
            </p>
            <p
              className={`${partOfVideo0 === 3 && "active"}`}
              onClick={() => {
                resetAnimation(3, 0);
                setPartOfVideo0(3);
              }}
            >
              <FormattedMessage id="home.mainvideo.text4" />
            </p>
          </div>
          <div className="timeline timeline0">
            <div
              className={`bar ${
                partOfVideo0 === 0
                  ? "part0"
                  : partOfVideo0 === 1
                  ? "part1"
                  : partOfVideo0 === 2
                  ? "part2"
                  : partOfVideo0 === 3
                  ? "part3"
                  : ""
              }`}
            ></div>
            <div
              onClick={() => {
                resetAnimation(0, 0);
                setPartOfVideo0(0);
              }}
              className={`point ${partOfVideo0 >= 0 && "active"}`}
            ></div>
            <div
              onClick={() => {
                resetAnimation(1, 0);
                setPartOfVideo0(1);
              }}
              className={`point ${partOfVideo0 >= 1 && "active"}`}
            ></div>
            <div
              onClick={() => {
                resetAnimation(2, 0);
                setPartOfVideo0(2);
              }}
              className={`point ${partOfVideo0 >= 2 && "active"}`}
            ></div>
            <div
              onClick={() => {
                resetAnimation(3, 0);
                setPartOfVideo0(3);
              }}
              className={`point ${partOfVideo0 === 3 && "active"}`}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainVideo;
